import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
//import CardHeader from '@material-ui/core/CardHeader';
import Paper from '@material-ui/core/Paper';
import CardContent from '@material-ui/core/CardContent';

import * as d3 from 'd3';

import StatisticsOverview from './statisticsOverview'
//import SocialMediaBlock from './socialMediaBlock'
import SocialMedia from './socialMedia'

const styles = theme => ({
  card: {
    display: 'flex column',
    margin: 0,
    borderColor: 'rgba(255,255,255,0)!important',
    boxShadow: '0px 0px 0px 0px rgba(255,255,255,0)!important',
    backgroundColor: '#f3f3f3',
    marginTop:'0px',
    [theme.breakpoints.down('xs')]: {
      marginTop:'30px',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop:'30px',
    },
    /*
    [theme.breakpoints.up('tablet')]: {
      fontSize:'14px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize:'15px',
    },
    */
    [theme.breakpoints.up('lg')]: {
      marginTop:'0px',
    },
  },
  cardHeader: {
    //backgroundColor: '#165469',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#fff',
    padding: '5px',
    paddingLeft: '20px',
    fontFamily: 'Flanders Art Sans!important',
    textAlign: 'left',
    fontSize: '1.1em',
    fontWeight: 500,
    borderRadius: '5px',
    minHeight:'48px',
  },
  imageBlock: {
    display: 'block',
    margin: '0 auto',
    textIndent: '-9999px',
    //background: 'url("/images/electricity_production.svg")',
    //width: '40px',
    //height: '40px',
    //backgroundSize: '40px 40px',
    backgroundSize: 'contain!important',
    backgroundRepeat: 'no-repeat!important',
    backgroundPosition: 'center center!important',
    width: '80%',
    height: 0,
    minWidth: '40px',
    maxWidth: '40px',
    minHeight: '40px',
    maxHeight: '40px',
  },
  solarOn: {
    background: 'url("/images/vea_selected_energy/solar_white.svg")',
  },
  solarOff: {
    background: 'url("/images/vea_selected_energy/solar_transp_blue.svg")',
  },
  onshoreWindOn: {
    background: 'url("/images/vea_selected_energy/onshoreWind_white.svg")',
  },
  onshoreWindOff: {
    background: 'url("/images/vea_selected_energy/onshoreWind_transp_blue.svg")',
  },
  offshoreWindOn: {
    background: 'url("/images/vea_selected_energy/offshoreWind_white.svg")',
  },
  offshoreWindOff: {
    background: 'url("/images/vea_selected_energy/offshoreWind_transp_blue.svg")',
  },

  cardContent: {
    padding: '0!important',
    marginTop: '20px;',
    height: '325px',
    position:'relative',
    [theme.breakpoints.down('xs')]: {
      minHeight: '400px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '400px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '380px',
    },
  },
});

function StatisticsOverviewCard(props) {
  const { classes } = props;
  /*
  let locale = d3.timeFormatDefaultLocale({
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "currency": ["€", ""],
    "dateTime": "%a %b %e %X %Y",
    "date": "%d.%m.%Y",
    "time": "%H:%M:%S",
    "periods": ["AM", "PM"],
    "days": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
    "shortDays": ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    "months": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
    "shortMonths": ["Jan", "Feb", "Maa", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"]
  })
  */
  let energyType
  switch (props.lang) {
    case "de":
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "Sonne und Wind onshore und offshore"
              : "Sonne und Wind onshore"
          )
            : (
              props.currentTech.windOffshore ?
                "Sonne und Wind offshore"
                : "Sonne"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "Wind onshore und offshore" :
                "Wind onshore"
            )
              : "Wind offshore"
          )
      )
      break
    case "en":
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "solar and wind onshore and offshore"
              : "solar and wind onshore"
          )
            : (
              props.currentTech.windOffshore ?
                "solar and wind offshore"
                : "solar"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "wind onshore and offshore" :
                "wind onshore"
            )
              : "wind offshore"
          )
      )
      break
    case "fr":
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "solaire et éolienne onshore et offshore"
              : "solaire et éolienne onshore"
          )
            : (
              props.currentTech.windOffshore ?
                "solaire et éolienne offshore"
                : "solaire"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "éolienne onshore et offshore" :
                "éolienne onshore"
            )
              : "éolienne offshore"
          )
      )
      break;
    case "nl":
    default:
      energyType = (
        props.currentTech.solar ? (
          props.currentTech.wind ? (
            props.currentTech.windOffshore ?
              "zon en wind onshore en offshore"
              : "zon en wind onshore"
          )
            : (
              props.currentTech.windOffshore ?
                "zon en wind offshore"
                : "zon"
            )
        )
          : (
            props.currentTech.wind ? (
              props.currentTech.windOffshore ?
                "wind onshore en offshore" :
                "wind onshore"
            )
              : "wind offshore"
          )
      )
  }

  let cardHeaderTitle

  switch (props.lang) {
    case "de":
      cardHeaderTitle = "Énergie " + energyType + " en Wallonie aujourd'hui"
      break
    case "en":
      cardHeaderTitle = energyType + " energy in Wallonie today"
      break
    case "fr":
      cardHeaderTitle = "Énergie " + energyType + " en Wallonie aujourd'hui"
      break
    case "nl":
    default:
      cardHeaderTitle = "Productie in Vlaanderen"
  }

  return (
    <Card className={classes.card}>
      <Paper className={classes.cardHeader + ' headerText bgdarkbluegreen'}>
        <div>
          <div>{cardHeaderTitle}</div>
          <div>{props.currentMode === "realtime"?d3.timeFormat('%d.%m.%Y')(props.selectedDate):props.yearSelected}</div>
        </div>
        <div style={{ display: "flex",paddingTop:'4px', }}>
          <div className={classes.imageBlock + " " + classes[(props.currentTech.solar ? 'solarOn' : 'solarOff')]}></div>
          <div className={classes.imageBlock + " " + classes[(props.currentTech.wind ? 'onshoreWindOn' : 'onshoreWindOff')]}></div>
          <div className={classes.imageBlock + " " + classes[(props.currentTech.windOffshore ? 'offshoreWindOn' : 'offshoreWindOff')]}></div>
        </div>
      </Paper>

      <CardContent className={classes.cardContent}>
        <StatisticsOverview
          statisticsData={props.statisticsData}
          currentTech={props.currentTech}
          currentMode={props.currentMode}
          yearSelected={props.yearSelected}
          dataLoaded={props.dataLoaded}
          lang={props.lang}
        />
        <div style={{ position:'absolute', bottom:'10px',right:'10px', width:'200px' }}>
          <SocialMedia
            source='indicators'
            currentTech={props.currentTech}
            currentMode={props.currentMode}
            yearSelected={props.yearSelected}
            daySelected={props.daySelected}
          />
        </div>
      </CardContent>
    </Card>
  );
}

StatisticsOverviewCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatisticsOverviewCard);
